<template>
  <v-app>
    <v-row class="px-4">
      <LoadingDialog v-if="loading" 
      :is_loading=loading />
      <v-col cols="12">
        <v-card 
          v-if="!loading" 
          elevation="0" 
          style="margin-top: 15px;">
          <v-card-title>
            {{ $t('_module_expert_ materiel_calepinage_') }}
          </v-card-title>
        </v-card>
        <v-card 
          v-if="!loading" 
          elevation="0">

          <v-card-text class="main-template">
            <!-- Installation details -->
             <div class="general-information">
           
              <tr 
                v-for="value in identification" 
                :key="'id' + value.name">
                 <td class="title-section">
                  <b>{{ $t(value.name) }} </b>
                </td>
                <td>
                  <div v-if="value.id == 'pc'" class="hc-identification">
                    : {{ (value.value / 1000).toFixed(2) }}
                  </div>                  
                  <div v-if="value.id != 'pc'" class="hc-identification">
                    : {{ value.value }} 
                  </div>
                </td>
              </tr>
            </div>
                  <!--  nb invertor per model table-->
            <v-data-table 
              class="hc-onduleur" 
              :items="invert" 
              :headers="headerInvert" 
              :items-per-page="-1"             
              hide-default-footer>
              <template v-slot:top>
                <v-toolbar flat style="background-color:#F2F4F4">
                  <v-toolbar-title>{{ $t('_type_et_nombres_onduleurs_') }}</v-toolbar-title>
                </v-toolbar>
              </template>
            </v-data-table>  
          

            
            <div class="div-hc-plane" >
              <v-data-table 
                    class =  "hc-plane "
                    height="200px" 
                    :items="plane" 
                    :headers="headerPlane" 
                    :items-per-page="-1"
                    fixed-header 
                    hide-default-footer>
                <template v-slot:top>
                  <v-toolbar flat style="background-color:#F2F4F4">
                    <v-toolbar-title>{{ $t('_rampants_') }}</v-toolbar-title>
                  </v-toolbar>
                </template>
              </v-data-table>
            </div>

            <!-- mpp table -->
            <v-data-table 
              class="hc-point-mesure-tab hc-point-mesure" 
              height="500px"
              :items="mpp" 
              :headers="mppHeader" 
              :items-per-page="-1"
              :custom-sort="customSort"
              :footer-props="{
                    'items-per-page-options': [20, 50, 100, -1],
                    'items-per-page-text': this.$t('_lignes_par_page_'),           
                  }"              

              dense>

      

              <template v-slot:top>




                <v-toolbar flat style="background-color:#F2F4F4">
                  <v-toolbar-title>{{ $t("_comparaion_du_calepinage_") }}</v-toolbar-title>
                </v-toolbar>
              </template>
              <template v-slot:[`item.nb_module_chaine_output`]="{ item }">
                <div v-if="item.nb_module_chaine_change" class="output-value change">
                  <p>{{ item.nb_module_chaine_output }}</p>
                </div>
                <div v-else class="output-value">
                  <p>{{ item.nb_module_chaine_output }}</p>
                </div>
              </template>

              <template v-slot:[`item.init_module_nb`]="{ item }">
                <td class="initial">
                {{ item.init_module_nb }}
                </td>
              </template>

              <template v-slot:[`item.init_string_nb`]="{ item }">
                <td class="initial">
                {{ item.init_string_nb }}
                </td>
              </template>

              
              <template v-slot:[`item.nb_chaine_parallele_output`]="{ item }">
                <div v-if="item.nb_chaine_parallele_change" class="output-value change">
                  <p>{{ item.nb_chaine_parallele_output }}</p>
                </div>
                <div v-else class="output-value">
                  <p>{{ item.nb_chaine_parallele_output }}</p>
                </div>
              </template>
            </v-data-table>
            <v-btn @click="downloadData()">{{ $t("_telecharger_le_tableau_comparatif_") }}</v-btn>

            <!-- map with point and address information -->
            <l-map 
              :key="refMap"
              :class="'map ' + sizeMap" 
              :zoom="zoom" 
              :center="center" 
              :options="{ attributionControl: false }">
              
              <l-tile-layer
               v-for="tileProvider in tileProviders" 
                :key="tileProvider.name" 
                :name="tileProvider.name"
                :visible="tileProvider.visible" 
                :url="tileProvider.url" 
                layer-type="base" />
              <l-control-layers position="topright" style="margin: 20px;" >
              </l-control-layers>

              <l-control :visible="true" position="bottomleft" style="z-index:10000; position: absolute; bottom:0px">
                <v-btn style="z-index:10000" @click="resizeMap()">
                  <v-icon > {{buttonSymbole}} </v-icon>
                </v-btn>
              </l-control>
              
              <l-marker 
                ref="mapRef" 
                :lat-lng="markerLatLng" 
                @ready="map_ready">
                <l-popup>
                  <b>
                    {{ site }}
                  </b>
                  <br />
                  {{ address }}
                  <br />
                  {{ postalCode }} , {{ city }}
                  <br />
                  <!-- {{ country }}
                  <br /> -->
                  <hr />
                  {{ markerLatLng[0] }},{{ markerLatLng[1] }}
                </l-popup>
              </l-marker>
              <button id="refreshButton">Refresh Button</button>
            </l-map>

          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-app>
</template>

<script>
  import api from "@/api/api";
  import LoadingDialog from "@/components/Utils/LoadingDialog";
  import "leaflet/dist/leaflet.css";

  export default {
    components: {
      LoadingDialog
    },

    //Initialize all value for the view
    mounted() {
      api.get_layout_model_global_info(this.installation_id).then((res) => {

        this.identification[0].value = res.data.prm
        this.identification[1].value = res.data.installed_power
        this.markerLatLng = [res.data.latitude, res.data.longitude]
        this.center = [res.data.latitude, res.data.longitude]
        this.address = res.data.address
        this.postalCode = res.data.postal_code
        this.city = res.data.city
        //this.country = res.data.country
        this.site = res.data.name
      })
      api.get_nb_inv_per_model(this.installation_id).then((res) => {
        this.invert = res.data
      })
      api.get_all_plane_information(this.installation_id).then((res) => {
        this.plane = res.data
      })
      this.get_layout()
    },

    data() {
      return {
        loading: false,
        installation_id: this.$route.params.id,

        //map information
        zoom: 15,
        markerLatLng: [0, 0],
        center: [48.866667, 2.333333],
        address: "8 rue de micheline",
        site: "Mon site",
        postalCode: "75000",
        sizeMap: "small-map",
        refMap: 0,
        buttonSymbole: "mdi-arrow-bottom-left",
        //country: "France",
        city: "Paris",
        mapRef: null,

        // value for map with map link and copyright
        tileProviders: [
          {
            url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png",
            visible: true,
            name: "satelliteESRI",
            attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
          },
          {
            url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
            visible: true,
            name: "OpenStreetMap",
            attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',

          }
        ],

        //Header for mesure points 
        mppHeader: [],
        mpp: [],

        //Header for invertor number per type
        headerInvert:
          [ ],

        //Header for plane details
        headerPlane:
          [],
        plane:
          [],

        //Installation details
        identification: [
          {
            id: 'prm',
            name: 'n° PRM',
            value: "",
            info: ""
          },
          {
            id: 'pc',
            name: '_puissance_crete_(kwc)_',
            value: "",
            info: "(vs. XXX fournis)"
          }
        ],
        invert: []

      };
    },

    computed: {
      installation() {
			return this.$store.getters.installations.find(
				(x) => x.id == this.installation_id
			);
		},
    },
    watch: {
      '$route': {
        async handler() {        
          this.refresHeader()
        },
        immediate: true,
      },

      '$root.$i18n.locale': {
        handler() {          
          this.refresHeader()
          this.get_layout()
        }
      }

    },

    methods: {
      downloadData(){
        api.convertJsonExpert({"data": {"input":this.mpp},  "header": this.mppHeader }, "xlsx","data_table" ,"", this.$root.$i18n.locale)
        .then((res)=>{
          let name = this.$t("_module_expert_ materiel_calepinage_")+ this.$route.params.id + ".xlsx"
          let a = document.createElement('a');
          a.href = URL.createObjectURL(res.data) ;
          a.download = name;
          a.click();}
        )
      },
      get_layout(){      
        const found =this.installation.elec_var.includes("Pac@grid")  
        
        api.get_all_full_layout(this.installation_id, this.$root.$i18n.locale, found).then((res) => {
        this.mpp = res.data
        //console.log(this.mpp)
      })
       
      },

      refresHeader(){
        this.mppHeader = [
          { key: "mpp", text: this.$t("_point_de_mesure_"), value: "mpp", sort: this.customIdSort, },
          { key: "plane_id", text: this.$t("_identifiant_rampant_"), value: "plane_id" },
          {key: "type_onduleur", text: this.$t("_type_onduleurs_"), value: "inv_model"},
          {key: "type_modules", text: this.$t("_type_modules_"), value: "pv_model"},
          { key: "module_nb", text: this.$t("_nb_modules_chaine_"), value: "module_nb" },
          { key: "string_nb", text: this.$t("_nb_chaines_en_parallele_"), value: "string_nb" },
          //{key: "modif", text: "_modification_", value: "modif"},
          {key: "init_module_nb", text: 'INITIAL '+ this.$t("_nb_modules_chaine_"), value: "init_module_nb"},
          {key: "init_string_nb", text: 'INITIAL '+ this.$t("_nb_chaines_en_parallele_"), value: "init_string_nb"},
        ],

        //Header for invertor number per type
        this.headerInvert =
          [
            { key: 'nb', text: this.$t('_nombre_d_onduleur_'), value: 'nb' },
            {key: 'model',  text: this.$t('_type_onduleurs_'), value:'techno_name'}
          ]

        //Header for plane details
        this.headerPlane =
          [
            { key: 'plane_id', text: this.$t('_identifiant_rampant_'), value: 'plane_id' },
            { key: 'pv_orientation', text: this.$t('_orientation_'), value: 'pv_orientation' },
            { key: 'pv_inclination', text: this.$t('_inclinaison_'), value: 'pv_inclination' },
            { key: 'installation_type', text: this.$t('_type_d_installation_'), value: 'installation_type' },
            { key: 'building_type', text: this.$t('_batiment_'), value: 'building_type' },
            { key: 'integration_type', text: this.$t('_integration_'), value: 'integration_type' },
          ]
      },

      resizeMap(){
        if (this.sizeMap == "full-screen-map"){
          this.sizeMap = "small-map"
          this.refMap = this.refMap + 1
          this.buttonSymbole = "mdi-arrow-bottom-left"
        } else {
          this.sizeMap = "full-screen-map"
          this.refMap = this.refMap + 1
          this.buttonSymbole = "mdi-arrow-top-right"
        }
      },

      getMenu() {
        return this.$store.getters.installations.find(x => x.id == this.$route.params.id)?.target_menu
      },
      map_ready() {
        this.$r
        
        this.refs.mapRef.mapObject.openPopup()
      },
      

      customIdSort(a,b){
        let a_1 = a.substr(0, a.indexOf('-'));
        let b_1 = b.substr(0, b.indexOf('-'));

        let a_2 = a.substr(a.indexOf('-')+1,a.length);
        let b_2 = b.substr(b.indexOf('-')+1,b.length);

        return (parseInt(a_1) - parseInt(b_1)) *10000+ parseInt(a_2) - parseInt(b_2)
       
      },
    
    },
  };
</script>

<style scoped>
  .v-select-like {
    border: 1px solid black !important;
    width: 100vw;
    display: block;
    border-radius: 4px;
    outline: none;
    color: black;
  }

  .vue-treeselect {
    font-size: 0.9rem;
    font-weight: normal;
  }

  .v-card__subtitle,
  .v-card__text,
  .v-card__title {
    padding: 16px 16px 16px 16px;
    border-bottom: #eee solid 1px;
  }

  html {
    overflow: hidden !important;
  }

  .name-value {
    font-weight: bold;
  }

  .v-data-table>>>tr:hover {
    background: none !important;
  }

  .hc-identification {
    
    height: auto;

  }

  .hc-onduleur {
   
    height: auto;
    border: grey 1px solid;
    grid-row: 2 ;
  }

  .hc-plane {
    border: grey 1px solid;
  
  }

  .div-hc-plane{
    grid-row: 3;
    grid-column: 1 / 3;
  }

  .v-data-table>>>.v-data-table-header {
    background-color: #F0F0F0 !important;
  }


  td tr{
    margin: 5px !important;
    padding: 0% !important;
    padding-right: 0px;
    padding-left: 0px;
    /*height: 0px;*/
  }

  .output-value {
    background-color: rgba(254, 149, 1, 50%);
    /*height: 100%;*/
    /*padding-top: auto;*/
    /*padding-bottom: auto;*/
    display: flex;
  }

  p {
    margin: auto;
  }

  .change {
    border: red solid 2px;
  }

  .main-template {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 0fr);
    padding: 20px;
    gap: 10px;
    height: min-content;
  }

  .general-information {
    grid-column: 1 ;
    grid-row: 1;
    height: min-content;
  
  }

  .map {
    grid-column: 2/2;
    grid-row-start: 1;
    grid-row-end: 3;
    justify-self: end;
 
  }

  .full-screen-map{
    height: 100vh;
    width: 100vw;
    position: fixed !important;
    top: 0px;
    left: 0px; 
    z-index: 10;
  }

  .small-map {
    
    width:100%;
    aspect-ratio: 1 / 1;
    z-index: 0;
            
  }

  .hc-point-mesure {
    /*margin: 2%;*/
    margin-bottom: 0%;
    border: grey 1px solid;
    grid-row: 4;
    grid-column: 1/3;
    height: fit-content;
  }

  .hc-point-mesure-tab {
    height: max-content;
  }

  .title-section {
    padding-right: 0px;
    width: 50%;
  }

  .initial{
    background-color: rgb(210,210,210);
  }
</style>
